/**
 * Lightweight pub/sub bus for REST API endpoint events.
 *
 * flatBufferBaseQuery calls `emitEndpointEvent()` after each API call.
 * The Terminal's EndpointMessagesContext subscribes when in endpoint mode.
 * Zero overhead when no listeners are registered — the emit function
 * early-returns before constructing any objects.
 */

import { EndpointMessageInterface } from "../../interfaces/EndpointMessage.interface";

type EndpointListener = (event: EndpointMessageInterface) => void;

const listeners = new Set<EndpointListener>();

let eventCounter = 0;

export function subscribeEndpointEvents(listener: EndpointListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitEndpointEvent(event: EndpointMessageInterface): void {
  if (listeners.size === 0) return;
  listeners.forEach((listener) => listener(event));
}

export function hasEndpointListeners(): boolean {
  return listeners.size > 0;
}

export function nextEndpointEventId(): string {
  eventCounter += 1;
  return `ep-${eventCounter}-${Date.now()}`;
}
